import React from 'react';
import { TabbedOverviewPage, /* AssessmentSuiteSection, */ WhatItMeasuresSection } from '../components/OverviewSections.comp';

// Tabs view temporarily disabled — only the first tab ("What Does the COS
// Children Assessment Measure?") renders, as a standalone page. Kept
// commented out (not removed) so it can be restored by swapping the
// active export below for this one.
// const AboutAssessmentPage = () => (
//     <TabbedOverviewPage
//         tabs={[
//             {
//                 label: 'What Does the Child Online Safety (COS) Children Assessment Measure?',
//                 content: <WhatItMeasuresSection />,
//             },
//             {
//                 label: 'Child Online Safety (COS) Assessments',
//                 content: <AssessmentSuiteSection />,
//             },
//         ]}
//     />
// );

const AboutAssessmentPage = () => (
    <TabbedOverviewPage
        skipNoDataGate
        tabs={[
            {
                label: 'What Does the Child Online Safety (COS) Children Assessment Measure?',
                content: <WhatItMeasuresSection />,
            },
        ]}
    />
);

export default AboutAssessmentPage;
